import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const languages = [
  { code: 'en', label: 'English' },
  { code: 'ar', label: 'العربية' },
  { code: 'es', label: 'Español' },
  { code: 'zh', label: '中文' },
  { code: 'hi', label: 'हिन्दी' },
  { code: 'ja', label: '日本語' }
];

const LANGUAGE_PREFERENCE_KEY = 'languagePreference';

const SwitcherContainer = styled.div`
  display: flex;
  align-items: center;
`;

const StyledSelect = styled.select`
  background: rgba(255, 255, 255, 0.1);
  color: ${props => props.theme.colors.white};
  border: 1px solid ${props => props.theme.colors.cardBorder};
  padding: 0.5rem;
  border-radius: 6px;
  cursor: pointer;
  font-family: inherit;
  font-size: 0.9rem;
  outline: none;
  transition: background-color ${props => props.theme.transitions.fast}, border-color ${props => props.theme.transitions.fast}, box-shadow ${props => props.theme.transitions.fast};

  &:hover {
    background: rgba(255, 255, 255, 0.2);
    border-color: ${props => props.theme.colors.primary};
  }

  &:focus {
    border-color: ${props => props.theme.colors.primary};
    box-shadow: 0 0 0 2px ${props => props.theme.colors.primaryGlow};
  }

  option {
    background-color: ${props => props.theme.colors.bgMedium};
    color: ${props => props.theme.colors.white};
  }
`;

const LanguageSwitcher = () => {
  const { t, i18n } = useTranslation();
  const [selectedLanguage, setSelectedLanguage] = useState(
    () => localStorage.getItem(LANGUAGE_PREFERENCE_KEY) || 'auto'
  );
  const [detectedLocation, setDetectedLocation] = useState(
    () => localStorage.getItem('detectedLocation') || ''
  );

  React.useEffect(() => {
    const handleLanguageDetection = (event) => {
      setDetectedLocation(event.detail?.location || '');
    };

    window.addEventListener('language-detected', handleLanguageDetection);
    return () => window.removeEventListener('language-detected', handleLanguageDetection);
  }, []);

  const changeLanguage = (lng) => {
    setSelectedLanguage(lng);

    if (lng === 'auto') {
      localStorage.setItem(LANGUAGE_PREFERENCE_KEY, 'auto');
      localStorage.removeItem('detectedLocation');
      localStorage.removeItem('detectedLanguage');
      setDetectedLocation('');
      localStorage.removeItem('hasCheckedIpLocation');
      window.dispatchEvent(new Event('language-auto-selected'));
      return;
    }

    localStorage.setItem(LANGUAGE_PREFERENCE_KEY, lng);
    i18n.changeLanguage(lng);
    document.documentElement.lang = lng;
    document.documentElement.dir = lng === 'ar' ? 'rtl' : 'ltr';
  };

  return (
    <SwitcherContainer>
      <StyledSelect
        id="language-select"
        name="language"
        value={selectedLanguage}
        onChange={(e) => changeLanguage(e.target.value)}
        aria-label={t('nav.language_label')}
      >
        <option value="auto">
          {detectedLocation ? `Auto (${detectedLocation})` : 'Auto'}
        </option>
        {languages.map((lang) => (
          <option key={lang.code} value={lang.code}>
            {lang.label}
          </option>
        ))}
      </StyledSelect>
    </SwitcherContainer>
  );
};

export default LanguageSwitcher;